export const ErrorType = {
  REDIRECT: 'REDIRECT' as const,
  FOUR_OH_FOUR: 'FOUR_OH_FOUR' as const,
  COLLECTOR_CLOSED: 'COLLECTOR_CLOSED' as const,
  INVALID_OPEN_ENDED_VALIDATION: 'INVALID_OPEN_ENDED_VALIDATION' as const,
  INVALID_SURVEY_VERSION: 'INVALID_SURVEY_VERSION' as const,
  MISSING_REQUIRED_FIELD: 'MISSING_REQUIRED_FIELD' as const,
} as const;

export default { ErrorType };
